<template>
    <div class="box">
        <div class="box-header">
            <h3 class="box-title">
                {{resource('DmVisualizer_ChangeInfo_BoxTitle')}}
            </h3>
        </div>
        
        <div class="box-body">
            <div class="row">
                <div class="col-4">
                    <info-logo
                            :isEnabled="logoEnabled"
                            @input="model.LogoPath = $event"
                            @set-enabled="logoEnabled = $event"
                    />
                    <info-opening-hours
                            :isEnabled="openingHoursEnabled"
                            @set-enabled="openingHoursEnabled = $event"
                            v-on:update:monday="model.OpeningHours.monday = $event"
                            v-on:update:tuesday="model.OpeningHours.tuesday = $event"
                            v-on:update:wednesday="model.OpeningHours.wednesday = $event"
                            v-on:update:thursday="model.OpeningHours.thursday = $event"
                            v-on:update:friday="model.OpeningHours.friday = $event"
                            v-on:update:saturday="model.OpeningHours.saturday = $event"
                            v-on:update:sunday="model.OpeningHours.sunday = $event"
                    />
                    <info-address
                            :isEnabled="addressEnabled"
                            @set-enabled="addressEnabled = $event"
                            v-on:update:street="model.AddressInfo.street = $event"
                            v-on:update:zipcode="model.AddressInfo.zipcode = $event"
                            v-on:update:houseNo="model.AddressInfo.houseNo = $event"
                            v-on:update:city="model.AddressInfo.city = $event"
                            v-on:update:country="model.AddressInfo.country = $event"
                    />
                    <info-website
                            :isEnabled="websiteEnabled"
                            @input="model.Website = $event"
                            @set-enabled="websiteEnabled = $event"
                    />
                </div>
                <div class="col-4">
                    <info-email
                            :isEnabled="emailEnabled"
                            @input="model.Email = $event"
                            @set-enabled="emailEnabled = $event"
                    />

                    <info-remarks
                            :isEnabled="remarksEnabled"
                            @input="model.Remarks = $event"
                            @set-enabled="remarksEnabled = $event"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-12 text-right">
                    <button class="btn btn-light mr-3" @click="$emit('cancel-change-info')">{{resource('DmVisualizer_ChangeInfo_CancelButton')}}</button>
                    <button class="btn btn-primary" @click="confirmRequest">{{resource('DmVisualizer_ChangeInfo_SendButton')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>   
    import resourceMixin from '../../../../Util/Mixins/resources';

    import dmVisualizerApi from '../../../../Api/dm-visualizer';
    import growler from "../../../../Util/growler";

    //Components
    import InfoLogo from './InfoLogo.vue';
    import InfoOpeningHours from './InfoOpeningHours.vue';
    import InfoAddress from './InfoAddress.vue';
    import InfoWebsite from './InfoWebsite.vue';
    import InfoEmail from './InfoEmail.vue';
    import InfoRemarks from "./InfoRemarks.vue";

    export default {
        name: "change-info",
        mixins: [resourceMixin],
        components: {
            InfoLogo,
            InfoOpeningHours,
            InfoAddress,
            InfoWebsite,
            InfoEmail,
            InfoRemarks
        },
        created(){
            this.indexLink = dmVisualizerApi.formatIndexUrl();
        },
        methods: {
            confirmRequest(){
                const vm = this;
                
                const { 
                    logoEnabled,
                    openingHoursEnabled,
                    addressEnabled,
                    websiteEnabled,
                    emailEnabled,
                    remarksEnabled
                } = vm;
                
                const model = {};
                
                //Only take the actual relevant, enabled keys
                if(logoEnabled) model.LogoPath = vm.model.LogoPath;
                if(openingHoursEnabled) model.OpeningHours = vm.model.OpeningHours;
                if(addressEnabled) model.AddressInfo = vm.model.AddressInfo;
                if(websiteEnabled) model.Website = vm.model.Website;
                if(emailEnabled) model.Email = vm.model.Email;
                if(remarksEnabled) model.Remarks = vm.model.Remarks;
                
                dmVisualizerApi.changeInfo(model)
                    .then(
                        () => window.location = vm.indexLink,
                        (err) => growler.bootstrapDanger(err.join('\n'))
                    );
            }
        },
        data() {
            return {
                indexLink: '',
                
                logoEnabled: false,
                openingHoursEnabled: false,
                addressEnabled: false,
                websiteEnabled: false,
                emailEnabled: false,
                remarksEnabled: false,
                //The idea is only add enabled info items to the model. But this is what it should look like
                //for the controller
                model: {
                    LogoPath: "",
                    OpeningHours: {

                    },
                    AddressInfo: {
                        
                    },
                    Website: "",
                    Email: "",
                    Remarks: ""
                }
            };
        }
    }
</script>

<style scoped src="../../Style/info.scss" lang="scss">
    
</style>
